"use client";

import { Menu, styled } from "@mui/material";

const CustomMenu = styled(Menu)({
  "& .MuiPaper-root": {
    border: "1px solid var(--border-default)",
    borderRadius: "var(--radius-md)",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.12)",
    minWidth: 160,
  },
  "& .MuiList-root": {
    padding: "4px",
  },
  "& .MuiMenuItem-root": {
    borderRadius: "var(--radius-sm)",
    font: "var(--text-body3)",
    color: "var(--text-primary)",
    padding: "8px 12px",
    justifyContent: "flex-start",
    "&:hover": {
      backgroundColor: "var(--bg-hover)",
    },
    "&.Mui-selected": {
      backgroundColor: "var(--action-primary-subtle)",
    },
  },
});

export default function ContextMenu({ anchorEl, onClose, labelledBy, children }) {
  const open = Boolean(anchorEl);

  return (
    <CustomMenu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      MenuListProps={{
        "aria-labelledby": labelledBy,
      }}
    >
      {children}
    </CustomMenu>
  );
}
